
<div class="row row-sm">
    <div class="col-lg-12">
        <!-- <div class="card custom-card"> -->
            <div class="card-body">  
                <div class="row">
                    <div class="col-md-12"> 
                        <div class="bc d-flex align-items-center pl-3">
                            <img alt="Logo" src="../../assets/img/fee.png" class="mh-45px pb-2">
                            <div *ngIf="submitButton" class="mb-0">
                                <h3 class="main-content-label mb-1"><b>Fees Head</b></h3>
                                <p class="text-muted card-sub-title mb-0">Add New Fees</p>
                            </div>
                            <div *ngIf="editButton" class="mb-0">
                                <h3 class="main-content-label mb-1"><b>Fees Head</b></h3>
                                <p class="text-muted card-sub-title mb-0 ">Update Selected Fee Head
                                </p>
                            </div>
                            <div *ngIf="deleteButton" class="mb-0">
                                <h3 class="main-content-label mb-1"><b>Fees Head</b></h3>
                                <p class="text-muted card-sub-title mb-0 ">Delete Selected Fee Head
                                </p>
                            </div>
                          </div> 
                    </div>
                    <hr class="mt-3">
 
 <div class="row row-sm mt-0 pt-0 add-form">
     <form autocomplete="off" class="p-0  mt-0 pt-0" novalidate [formGroup]="feeHeadForm">
        <div class="card-body mt-0 pt-0">

            <!-- <div class="card custom-card">
                <div class="card-body"> -->
                    <!-- <div *ngIf="submitButton" class="mb-3">
                        <h3 class="main-content-label mb-1"><b>Add New Fees</b></h3>
                        <p class="text-muted card-sub-title mb-0">Add New Fees</p>
                    </div>
                    <div *ngIf="editButton" class="mb-3">
                        <h3 class="main-content-label mb-1"><b>Update Selected Fee Head</b></h3>
                        <p class="text-muted card-sub-title mb-0 ">Update Selected Fee Head
                        </p>
                    </div>
                    <div *ngIf="deleteButton" class="mb-3">
                        <h3 class="main-content-label mb-1"><b>Delete Selected Fee Head</b></h3>
                        <p class="text-muted card-sub-title mb-0 ">Delete Selected Fee Head
                        </p>
                    </div> -->
                    <div class="row clearfix">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Head code</mat-label>
                                        <input required [readonly]="isUpdate || readDelete"
                                            onkeydown="return (event.keyCode!=13);" maxlength="6"
                                            class="color" matInput formControlName="HeadCode"
                                            placeholder="Head Code">
                                        <mat-error class="margin_tp"
                                            *ngIf="feeHeadForm.controls['HeadCode'].touched && feeHeadForm.controls['HeadCode'].errors?.required">
                                            Mandatory
                                        </mat-error>
                                        <mat-error class="margin_tp"
                                            *ngIf="feeHeadForm.controls['HeadCode'].touched && feeHeadForm.controls['HeadCode'].errors?.pattern">
                                            Invalid
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Head</mat-label>
                                        <input required [readonly]="readDelete"
                                            onkeydown="return (event.keyCode!=13);" maxlength="50"
                                            class="color" matInput formControlName="Head"
                                            placeholder="Head">
                                        <mat-error class="margin_tp"
                                            *ngIf="feeHeadForm.controls['Head'].touched && feeHeadForm.controls['Head'].errors?.required">
                                            Mandatory
                                        </mat-error>
                                        <mat-error class="margin_tp"
                                            *ngIf="feeHeadForm.controls['Head'].touched && feeHeadForm.controls['Head'].errors?.pattern">
                                            Invalid
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>
                                            Cg/Uni
                                        </mat-label>
                                        <mat-select required [disabled]="readDelete" #select333
                                            class="colorblack" formControlName="Uni_Colg">
                                            <mat-select-filter *ngIf="select333.focused"
                                                [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                [array]="cgList"
                                                (filteredReturn)="filteredcgList =$event"></mat-select-filter>
                                            <mat-option *ngFor="let item of filteredcgList"
                                                [value]="item.CdCode">
                                                {{item.CdDesc}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error class="margin_tp"
                                            *ngIf="feeHeadForm.controls['Uni_Colg'].touched && feeHeadForm.controls['Uni_Colg'].errors?.required">
                                            Mandatory
                                        </mat-error>
                                    </mat-form-field>

                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>
                                            Purpose
                                        </mat-label>
                                        <mat-select required [disabled]="readDelete" #select25
                                            class="colorblack" formControlName="Purpose">
                                            <mat-select-filter *ngIf="select25.focused"
                                                [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                [array]="purposeList"
                                                (filteredReturn)="filteredpurposeList =$event"></mat-select-filter>
                                            <mat-option *ngFor="let item of filteredpurposeList"
                                                [value]="item.CdCode">
                                                {{item.CdDesc}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error class="margin_tp"
                                            *ngIf="feeHeadForm.controls['Purpose'].touched && feeHeadForm.controls['Purpose'].errors?.required">
                                            Mandatory
                                        </mat-error>
                                    </mat-form-field>

                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label>Amount</mat-label>
                                        <input onkeydown="return (event.keyCode!=13);"  maxlength="" class="color" matInput formControlName="Amount"
                                            placeholder="Head" >
                                            <mat-error class="margin_tp"
                                                *ngIf="feeHeadForm.controls['Amount'].touched && feeHeadForm.controls['Amount'].errors?.required">
                                                This Field Is Mandatory
                                            </mat-error>
                                            <mat-error class="margin_tp"
                                            *ngIf="feeHeadForm.controls['Amount'].touched && feeHeadForm.controls['Amount'].errors?.pattern">
                                            Please Enter Valid Data
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div> -->
                        <!-- <div class="col-sm-12">
                            <button type="button"
                                class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                (click)="save()" *ngIf="submitButton && feeCreate">Save</button>
                            <button type="button"
                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                *ngIf="editButton && feeUpdate" (click)="update()">Update</button>
                            <button type="button"
                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                *ngIf="deleteButton && feeDelete"
                                (click)="DeletetheRecord()">Delete</button>
                            <button type="button"
                                class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                (click)="addnewrecord('false')">Back</button>
                        </div> -->
                        <div class="row col-sm-12">
                            <div class="col-sm-12 prpl">
                                <button type="button" *ngIf="deleteButton && feeDelete"
                                class="btn btn-primary btn-icon-text floatright mt-1"
                                (click)="DeletetheRecord()">
                                <span style="display: contents; align-items: center;">
                                     <img width="20vh" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                                    Delete
                                </span>
                                </button>
                                <button type="button"  *ngIf="editButton && feeUpdate"
                                class="btn btn-primary btn-icon-text floatright mt-1"
                                (click)="update()">
                                <span style="display: contents; align-items: center;">
                                     <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                                     Update
                                </span>
                                </button>
                                <button type="button" *ngIf="submitButton && feeCreate"
                                class="btn btn-primary btn-icon-text floatright mt-1"
                                (click)="save()">
                                <span style="display: contents; align-items: center;">
                                     <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                     Save
                                </span>
                                </button>
                                <button type="button" [mat-dialog-close]="true"
                                class="btn btn-primary btn-icon-text floatright mr-3 mt-1 ">
                                <span style="display: contents; align-items: center;">
                                     <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px ;">
                                      Back
                                </span>
                            </button>
                            </div>
                        </div>
                       
                    </div>
                <!-- </div>
            </div> -->
        </div>
    </form>
</div>
</div>
</div>
<!-- </div> -->
</div>
</div>

